import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      // Coming back to the tab refreshes anything older than staleTime, so a dashboard left
      // open over a lesson is not read as current when it is half an hour stale.
      refetchOnWindowFocus: true,
    },
  },
});
